import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    submittingFormInProgress: false,
    submittingFormError: null,

    allUsers: [],
    selectedUser: null,

    selectedUserRoles: [],
    selectedUserRole: null,

    formStatus: 'viewOnly',
    authTypeFormStatus: 'viewOnly',

    addPopupVisible: false,
    removeAuthTypePopupVisible: false,
    addAuthTypePopupVisible: false,

    personList: [],
};

const addUserSlice = createSlice({
    name: 'addUser',
    initialState,
    reducers: {
        fetchUsersStart(state, { payload }) {
            state.submittingFormError = null;
        },
        fetchSelectedUserRolesStart() {},
        fetchUsersSuccess(state, { payload: users }) {
            state.allUsers = users;
        },
        addUsers() {},
        setSelectedUser(state, { payload }) {
            state.selectedUser = payload ? state.allUsers.find((person) => person.id === payload) : null;
        },

        fetchSelectedUserRolesSuccess(state, { payload: roles }) {
            state.selectedUserRoles = roles;
        },
        setSelectedRole(state, { payload }) {
            state.selectedUserRole = payload ? state.selectedUserRoles.find((role) => role.id === payload) : null;
        },
        setFormStatus(state, { payload: formStatus }) {
            state.formStatus = formStatus;
        },
        resetState(state) {
            state.submittingFormInProgress = false;
            state.submittingFormError = null;
            state.formStatus = 'viewOnly';
            state.allUsers = [];
            state.selectedUser = null;
            state.selectedUserRoles = [];
            state.selectedUserRole = null;
            state.personList = [];
        },
        setRemovePopupVisible(state, { payload }) {
            state.removePopupVisible = payload;
        },
        setRemoveRolePopupVisible(state, { payload }) {
            state.removeAuthTypePopupVisible = payload;
        },
        setAddRolePopupVisible(state, { payload }) {
            state.addAuthTypePopupVisible = payload;
        },
        setAddPopupVisible(state, { payload }) {
            state.addPopupVisible = payload;
        },
        fetchPersonStart() {},
        fetchPersonError(state, { payload: error }) {
            state.fetchingPersonError = error;
        },
        fetchPersonSuccess(state, { payload: personList }) {
            state.personList = personList;
        },
        deleteUserRoles() {},
        addUserRoles() {},
    },
});

export const addUserActions = addUserSlice.actions;
export const addUserReducer = addUserSlice.reducer;
